
import { Component, Vue } from 'vue-property-decorator';

@Component({})

export default class RouterMethods extends Vue {
    public projectRoutes: string[] = [
        '/admin/projects',
        '/admin/unit-groups',
        '/admin/unit-types',
        '/admin/units',
        '/admin/groupings',
    ];

    public administrationRoutes: string[] = [
        '/admin/localization',
        '/admin/integrations',
        '/admin/permissions',
        '/admin/user-management/staff',
    ];

    public waitingListRoutes: string[] = [
        '/admin/waiting-lists',
        '/admin/presentation-flow',
    ];

    public helpDeskRoutes: string[] = [
        '/admin/tickets',
        '/admin/ticket/attributes',
        '/admin/messages',
    ];

    public requireAutoHeightRoutes: string[] = [
        'admin-unit-details',
    ];

    get isProjectRoutes() {
        return this.projectRoutes.includes(this.$route.path);
    }

    get isAdministrationRoutes() {
        return this.administrationRoutes.includes(this.$route.path);
    }

    get isWaitingListRoutes() {
        return this.waitingListRoutes.includes(this.$route.path);
    }

    get isHelpDeskRoutes() {
        return this.helpDeskRoutes.includes(this.$route.path);
    }

    get isRequireAutoHeightRoutes() {
        return this.requireAutoHeightRoutes.includes(this.$route.name);
    }
}
